import { render, staticRenderFns } from "./MultitaskContainer.vue?vue&type=template&id=328d698a&scoped=true&"
import script from "./MultitaskContainer.vue?vue&type=script&lang=js&"
export * from "./MultitaskContainer.vue?vue&type=script&lang=js&"
import style0 from "./MultitaskContainer.vue?vue&type=style&index=0&id=328d698a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328d698a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
